import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

if (document.readyState !== 'loading') {
    initWidget();
} else {
    window.addEventListener('DOMContentLoaded', () => {
        initWidget();
    });
}

function initWidget() {
    const figures = document.querySelectorAll('.js-figure');

    if (figures) {
        gsap.registerPlugin(ScrollTrigger);
        ScrollTrigger.defaults({
            toggleActions: 'restart none none none',
        });

        figures.forEach((figure) => {
            const { figureStart, figureEnd, figureDuration } = figure.dataset;
            const numberElement = figure.querySelector('.js-figure-number');
            const counting = { val: figureStart };

            gsap.to(counting, {
                scrollTrigger: {
                    trigger: figure,
                    start: 'top bottom-=50px',
                },
                val: figureEnd,
                duration: figureDuration,
                onUpdate: () => {
                    const number = gsap.utils.snap(1, counting.val);
                    numberElement.innerHTML = new Intl.NumberFormat('de-CH').format(number);
                },
            });
        });
    }
}
